import React from 'react'
import {renderMoney} from "../../utils";
import '../../css/page/refundComponent.css'

class RefundApply extends React.Component {
    renderProductType(product_type) {
        switch (product_type) {
            case 'liveroom_vip':
                return 'VIP会员'
            case 'pay_lecture':
                return '课程标题'
            case 'gift_lecture':
                return '课程赠礼'
            case 'pay_channel':
            case 'pay_operate_channel':
                return '专栏标题'
            case 'gift_channel':
                return '专栏赠礼'
            case 'pay_schedule':
                return '打卡活动'
            case 'pay_channel_groupbuy':
                return '专栏拼团'
            case 'pay_member':
                return '荔枝微课会员'
            case 'pay_channel_member':
                return '会员免费听'
            default:
                return ''
        }
    }

    render() {
        const {isShow, data} = this.props;

        if (!isShow) {
            return null
        }
        return (
            <div className="refund-apply dialog__area">
                <div className="refund-apply-body">
                    <div className="refund-apply-title">
                        <span className="refund-apply-title__tips">
                            {data.account_info.nickname}的退款申请
                        </span>
                    </div>
                    <div className="refund-apply-list-panel-userinfo">
                        <span>
                            <i>用户昵称</i>
                            <p>{data.account_info.nickname}</p>
                        </span>
                        {['pay_lecture', 'pay_channel', 'pay_operate_channel'].indexOf(data.product_type) > -1 ?
                            <span>
                                <i>{this.renderProductType(data.product_type)}</i>
                                <p>{data.product_info.name}</p>
                            </span>
                            :
                            <span>
                                <i>标<span style={{visibility: " hidden", display: "inline-block", marginTop: 0}}> 隔断</span>题</i>
                                <p>{this.renderProductType(data.product_type)}</p>
                            </span>
                        }
                        <span>
                            <i>金<span style={{visibility: " hidden", display: "inline-block", marginTop: 0}}> 隔断</span>额</i>
                            <p>{renderMoney(data.fee)}元</p>
                        </span>
                        <span>
                            <i>退款原因</i>
                            <p>{data.refund_reason}</p>
                        </span>
                        <span>
                            <i>备<span style={{visibility: " hidden", display: "inline-block", marginTop: 0}}> 隔断</span>注</i>
                            <p>{ data.invoice_remark }</p>
                        </span>
                        <span>
                            <i>联系方式</i>
                            <p>{data.account_info.telephone}</p>
                        </span>
                    </div>
                </div>
                <div className="refund-apply-btnGroup">
                    <span className="agree-to-refund refund-apply-1pxBorderTop"
                          onClick={() => this.props.clickHandle.handleApply()}>同意申请</span>
                    <span className="reject-to-refund refund-apply-1pxBorderTop"
                          onClick={() => this.props.clickHandle.handleReject()}>拒绝申请</span>
                    <span className="cancel-refund refund-apply-1pxBorderTop"
                          onClick={() => this.props.clickHandle.handleClose()}>取消</span>
                </div>
            </div>
        )
    }
}

export default RefundApply


// WEBPACK FOOTER //
// ./src/pages/refund/refundApply.js